import { render, staticRenderFns } from "./OrganizationUpdateForm.vue?vue&type=template&id=f4e5af86&scoped=true&"
import script from "./OrganizationUpdateForm.vue?vue&type=script&lang=js&"
export * from "./OrganizationUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e5af86",
  null
  
)

export default component.exports